// src/utils/eventBus.js
import { reactive, readonly } from 'vue'

const state = reactive({
  latestOpenEventUid: null
})

const methods = {
  // Metodo chiamato quando un dropdown si apre
  notifyOpen (uid) {
    state.latestOpenEventUid = uid
  },
  // Metodo per controllare se il dropdown corrente deve chiudersi
  shouldClose (currentUid) {
    return state.latestOpenEventUid !== currentUid && state.latestOpenEventUid !== null
  },
  reset () {
    state.latestOpenEventUid = null
  }
}

export default {
  state: readonly(state),
  ...methods
}
